import { useState, useEffect } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage-wrapper">
      {/* Background Video - Desktop */}
      <video 
        className="homepage-bg-video homepage-bg-video-desktop"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/assets/bg-lobby.mp4" type="video/mp4" />
      </video>
      
      {/* Background Video - Mobile */}
      <video 
        className="homepage-bg-video homepage-bg-video-mobile"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/assets/bg-lobby-mb.mp4" type="video/mp4" />
      </video>
      
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      
      {/* Logo for all devices */}
      <div 
        className="homepage-logo"
        style={{
          position: 'relative',
          width: '100%',
          textAlign: 'center',
          marginTop: '20px',
          marginBottom: '20px'
        }}
      >
        <img 
          src="/assets/logo-v1e.png" 
          alt="Logo" 
          className="logo-image"
          style={{
            maxWidth: '500px',
            height: 'auto',
            display: 'block',
            margin: '0 auto'
          }}
        />
      </div>
      
      <GameList />
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
      
      <style>{`
        .homepage-wrapper {
          position: relative;
          min-height: 100vh;
          overflow: hidden;
        }
        
        .homepage-bg-video {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          object-fit: cover;
          object-position: center center;
          z-index: -1;
        }
        
        .homepage-bg-video-mobile {
          display: none;
        }
        
        @media (max-width: 768px) {
          .homepage-bg-video-desktop {
            display: none;
          }
          .homepage-bg-video-mobile {
            display: block;
          }
          .logo-image {
            max-width: 80% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default HomePage;
